import { render, staticRenderFns } from "./workflow-feedback-status-table.vue?vue&type=template&id=d1ecad6e"
import script from "./workflow-feedback-status-table.vue?vue&type=script&lang=js"
export * from "./workflow-feedback-status-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports